import type { SupTransmuteType } from "@/hooks/api/erc20/useErc20Transmute";
import React, { Fragment } from "react";

import Link from "next/link";
import dictionaryConfig from "@/../config/dictionary.config";
import { SupButton, SupText } from "@repo/core-ui";
import { SupMint } from "@repo/core-ui";

interface Web3TransmuteFinishedProps {
  title?: string;
  description?: string;
  handleClose?: () => void;
  closeLabel?: string;
  type?: SupTransmuteType;
  handleWithdraw?: () => void;
  showLink?: boolean;
  extraContent?: React.ReactNode;
}

export default function Web3TransmuteFinished({ title, description, type, handleClose, handleWithdraw, closeLabel = "Done", showLink, extraContent }: Web3TransmuteFinishedProps) {
  const preparedTitle = title || "SuperPositions Transmuted";
  const preparedDescription = description || `Your SuperPositions are now in ${type} form and ${type === "ERC20" ? "can be used in other protocols" : "earning XP"}.`;

  return (
    <Fragment>
      <div className="my-[8px] flex w-full flex-col items-start justify-center space-y-[8px]">
        <div className="inline-flex h-fit w-full flex-col items-start justify-start space-y-4 border-[.5px] border-[#24A167]/16 bg-[#24A167]/4 p-4">
          <div className="inline-flex items-center gap-2 text-neutral-800">
            <SupMint className="h-4 w-4" />
            <SupText variant="caption" weight="bold">
              {preparedTitle}
            </SupText>
          </div>
          <SupText variant="caption" className="self-stretch normal-case text-neutral-700">
            {preparedDescription}
          </SupText>
          {showLink && (
            <Link href={dictionaryConfig.superPools.helpArticle} className="text-neutral-700 underline hover:no-underline" target="_blank">
              <SupText variant="caption" weight="bold" className="self-stretch ">
                Learn More
              </SupText>
            </Link>
          )}
          {extraContent && extraContent}
        </div>
      </div>
      <div className="mt-auto flex w-full flex-col items-stretch justify-between space-y-4">
        {handleClose && (
          <div className="flex w-full flex-col items-stretch justify-between space-y-4">
            <SupButton fluid onClick={handleClose} variant={handleWithdraw ? "outlined" : "contained"}>
              {closeLabel}
            </SupButton>
          </div>
        )}
        {handleWithdraw && (
          <div className="mt-auto flex w-full flex-col items-stretch justify-between space-y-4">
            <SupButton fluid onClick={handleWithdraw}>
              Withdraw Assets
            </SupButton>
          </div>
        )}
      </div>
    </Fragment>
  );
}
